/*
  Spinner Component with using create Portal
*/
import {createPortal} from 'react-dom';
import {Spinner} from '@shopify/polaris'; //Using Polaris Spinner Component
import styles from './spinnerComponent.module.scss';

//Spinner Component
const SpinnerComponent = () => {
  //get the element whose id is overlayRoot
  const overlayNode = document.getElementById('overlayRoot') as HTMLElement;

  //return the spinner with use of createPortal
  return (
    createPortal(
      <div className={styles.overlay}>
        <Spinner accessibilityLabel="Loading" size="large" />
      </div>,
      overlayNode)
  );
};
//Export the default spinner component
export default SpinnerComponent;
